import { debounce } from "loop-utils";

document.addEventListener("DOMContentLoaded", function () {
  const updateAddToCartBtnState = debounce((e) => {
    const resource = e.detail.resource;

    const buttons = document.querySelectorAll('[ref="addToCartButton"]');
    const buttonArray = Array.from(buttons);

    if (!buttonArray.length) {
      return;
    }

    const selectedVariantTitle = resource.option2?.toLowerCase().trim();

    if (selectedVariantTitle === "pick a protein bundle") {
      buttonArray.forEach((button) => {
        button.setAttribute("disabled", "true");
      });
    } else {
      buttonArray.forEach((button) => {
        button.removeAttribute("disabled");
      });
    }
  }, 100);
  document.addEventListener("variant:update", updateAddToCartBtnState);

  const updateSubOptSelectorState = (e) => {
    const resource = e.detail.resource;

    const option2 = resource.option2?.toLowerCase();

    if (!option2) {
      return;
    }

    const subOptionsContainer = document.querySelector(
      ".loop-widget-container",
    );

    if (!subOptionsContainer) {
      console.error("subOptionsContainer not found");
      return;
    }

    if (option2.includes("pick a protein bundle")) {
      subOptionsContainer.classList.add("disabled");
    } else {
      subOptionsContainer.classList.remove("disabled");
    }
  };
  document.addEventListener("variant:update", updateSubOptSelectorState);
});
